export default "__VITE_ASSET__m1CzZhj0__"